/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import { useGetPrecoRegra } from "~hooks/useBackOffice";
import prepareForOptions from "~services/utils/prepareForOptions";
import { db } from "~/db/db";
import { getLocalStorage, saveLocalStorage } from "~services/utils/SaveIndexBD";
import { useSmartEffect } from "~hooks/useSmart";

const useProdutoV2 = ({
  grupoProduto,
  gruposProduto,
  type = "filtrado",
  filialForm,
  gruposMateriaisDisponiveis,
  produtosDisponiveis,
  camposOpt = ["codigo", "descricaoProduto"],
  typeOptions = "single",
  replicacao = false,
  produto,
}) => {
  const [enabledPrecoProduto, setEnabledPrecoProduto] = useState(false);

  const [filial, setFilial] = useState(0);
  const [microrregiao, setMicrorregiao] = useState(0);
  const [produtoSimulacao, setProdutoSimulacao] = useState({});

  const [produtos, setProdutos] = useState([]);

  useSmartEffect(() => {
    const fetchProdutos = async (signal) => {
      let query = db.produtos;
      let wheres = 0;

      if (grupoProduto > 0) {
        query = query.where("grupoMaterialId").equals(grupoProduto);
        wheres++;

        if (filialForm && gruposMateriaisDisponiveis?.["key-" + grupoProduto]?.filiais?.["key-" + filialForm]) {
          const ids = Object.keys(gruposMateriaisDisponiveis["key-" + grupoProduto].filiais["key-" + filialForm]).map(
            (e) => parseInt(e)
          );
          if (ids.length > 0) {
            query = query.and((c) => ids.includes(c.id));
            wheres++;
          }
        }
      }

      if (gruposProduto?.length > 0 && !grupoProduto) {
        const idsArray = [];
        gruposProduto.forEach((g) => {
          const cur = gruposMateriaisDisponiveis?.["key-" + g.id]?.filiais;
          if (cur) {
            Object.values(cur).forEach((f) => {
              const grupoFilialMateriais = Object.keys(f).map((e) => parseInt(e));
              idsArray.push(...grupoFilialMateriais); // Usar push para evitar a criação de novos arrays
            });
          }
        });

        if (idsArray.length > 0) {
          query = query.where("id").anyOf(idsArray);
          wheres++;
        }
      }

      if (produtosDisponiveis?.length > 0) {
        query =
          wheres > 0
            ? query.and((c) => produtosDisponiveis.includes(c.id))
            : query.where("id").anyOf(produtosDisponiveis);
      }

      if (replicacao) {
        query = query.filter((a) => a.replicacaoAtiva !== false);
      }

      const produtosTemp = [];
      if (!grupoProduto && type !== "geral") setProdutos(produtosTemp);
      else {
        await query.filter((a) => a.ativo).each((item) => produtosTemp.push(item));
      }
      if (!signal.aborted) {
        setProdutos(produtosTemp);
      }
    };

    const controller = new AbortController();
    const { signal } = controller;

    fetchProdutos(signal);

    return () => {
      controller.abort();
    };
  }, [grupoProduto, gruposProduto, filialForm, gruposMateriaisDisponiveis, produtosDisponiveis, replicacao, type]);

  const optionProdutos = useMemo(
    () =>
      prepareForOptions(
        (produtos || []).sort((a, b) => a.descricaoProduto.localeCompare(b.descricaoProduto)),
        camposOpt,
        "id"
      ),
    [produtos]
  );

  const produtoPrecoRequest = useGetPrecoRegra(produto, filial, microrregiao, enabledPrecoProduto);

  useEffect(() => {
    if (produtoPrecoRequest.data) {
      db.precoProduto.put(produtoPrecoRequest.data);
    }
  }, [produtoPrecoRequest.data]);

  function setIndexDBProdutoSimulacao(idCliente, values) {
    saveLocalStorage("produto-simulacao-nova-" + idCliente, values, true);
  }

  async function getIndexDBProdutoSimulacao(idCliente) {
    const data = getLocalStorage("produto-simulacao-nova-" + idCliente, true);
    if (data) {
      setProdutoSimulacao(data);
    }
  }

  useEffect(() => {
    if (Object.keys(produtoSimulacao).length > 0 && microrregiao > 0) {
      setFilial(produtoSimulacao.filialId);
      setEnabledPrecoProduto(true);
    }
  }, [produto, microrregiao]);

  useEffect(() => {
    if (grupoProduto && grupoProduto != 0 && produto && produto != 0 && typeOptions != "multi") {
      const checkProductExists = async () => {
        await db.produtos
          .where("grupoMaterialId")
          .equals(grupoProduto)
          .and((c) => c.id == produto)
          .count();
      };

      checkProductExists();
    }
  }, [grupoProduto, produto]);

  return {
    produtos,
    optionProdutos,
    setIndexDBProdutoSimulacao,
    getIndexDBProdutoSimulacao,
    produtoSimulacao,
    precoProdutoLoader: produtoPrecoRequest.isLoading,
    setMicrorregiao,
  };
};

export default useProdutoV2;
